import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { SERVER_API_URL } from 'src/app/app.constants';
import { createRequestOption } from 'src/app/shared/util/request-util';
import { IClauseExtensionMySuffix } from 'src/app/shared/model/clause-extension-my-suffix.model';

type EntityResponseType = HttpResponse<IClauseExtensionMySuffix>;
type EntityArrayResponseType = HttpResponse<IClauseExtensionMySuffix[]>;
type FileEntityType = HttpResponse<Blob>;

@Injectable({ providedIn: 'root' })
export class ClauseExtensionMySuffixService {
    private resourceUrl = SERVER_API_URL + 'api/clause-extensions';
    private resourceUrlByType = SERVER_API_URL + 'api/clause-extensions/by';

    constructor(private http: HttpClient) {}

    create(clauseExtension: IClauseExtensionMySuffix): Observable<EntityResponseType> {
        return this.http.post<IClauseExtensionMySuffix>(this.resourceUrl, clauseExtension, { observe: 'response' });
    }

    update(clauseExtension: IClauseExtensionMySuffix): Observable<EntityResponseType> {
        return this.http.put<IClauseExtensionMySuffix>(this.resourceUrl, clauseExtension, { observe: 'response' });
    }

    find(id: number): Observable<EntityResponseType> {
        return this.http.get<IClauseExtensionMySuffix>(`${this.resourceUrl}/${id}`, { observe: 'response' });
    }

    query(req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        return this.http.get<IClauseExtensionMySuffix[]>(this.resourceUrl, { params: options, observe: 'response' });
    }

    delete(id: number): Observable<HttpResponse<any>> {
        return this.http.delete<any>(`${this.resourceUrl}/${id}`, { observe: 'response' });
    }

    getByType(type: string): Observable<HttpResponse<any>> {
        return this.http.get<IClauseExtensionMySuffix>(`${this.resourceUrlByType}/${type}`, { observe: 'response' });
    }

    uploadFileService(fileData): Observable<any> {
        const _url = SERVER_API_URL + 'api/file/save';
        return this.http.post<any>(_url, fileData, { observe: 'response' });
    }

    downloadFileService(fileId: string): Observable<Blob> {
        const _url = SERVER_API_URL + 'api/file/get/' + fileId;
        return this.http.get(_url, { responseType: 'blob' }).map(blob => {
            // window.open(_url);
            return blob;
        });
    }

    deleteFileService(fileId: string): Observable<HttpResponse<any>> {
        const _url = SERVER_API_URL + 'api/file/delete/' + fileId;
        const param = new HttpParams();
        param.set('fileId', fileId);
        return this.http.get<IClauseExtensionMySuffix>(_url, { params: param, observe: 'response' });
    }

    queryAll(req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        return this.http.get<IClauseExtensionMySuffix[]>(this.resourceUrl + '/all', { params: options, observe: 'response' });
    }
    queryAllForMapping(req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        return this.http.get<IClauseExtensionMySuffix[]>(this.resourceUrl + '/all/mapping', { params: options, observe: 'response' });
    }
    findByIdAndFromEffectiveDate(id: number, fromEffectiveDate: string): Observable<EntityResponseType> {
        return this.http.get<IClauseExtensionMySuffix>(`${this.resourceUrl}/${id}/${fromEffectiveDate}`, { observe: 'response' });
    }

    get(url:string):Observable<any>{
        return this.http.get<any>(SERVER_API_URL + url, { observe: 'response' });
    }
    
}
